/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export const { converse } = window;
